import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import settingsStore from './settings';
import TR from './../Trans';
import bgPerformanceStore from './bgPerformance';

const initialState = {
  isWaiting: false,
  filters: null,
  playerFilter: null,
  currentFilter: null,
  totalCount: 0
};

const bgFiltersStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setToPlayerFilter: (filter) => {
    console.log("playerFilter", filter)
    if (filter) {
      if (filter.criteria) {
        let langFilters = {};
        let genreFilters = {};
        let decadeFilters = {};
        let items = filter.criteria.items;
        if (items) {
          items.forEach((arr) => {

            arr.forEach((criteria) => {

              switch (criteria.key) {
                case "language_id":
                  langFilters[criteria.value] = true;
                  break;
                case "genre_id":
                  genreFilters[criteria.value] = true;
                  break;
                case "decade":
                  decadeFilters[criteria.value] = true;
                  break;
              }
            });
          });
        }
        filter.filterLanguages = langFilters;
        filter.filterGenres = genreFilters;
        filter.filterDecades = decadeFilters;
        console.log("playerFilter")
        set({ playerFilter: { ...filter } });
      }
    }
  },
  emptyPlayerFilter: () => {
    set({ playerFilter: null });
  },
  setPlayerFilter: (filterId) => {
    let filters = get().filters;
    console.log("playerFilter")
    if (filters) {
      let filterIndex = filters.findIndex(x => x.id == filterId);
      console.log("playerFilter", filterIndex, filters, filterId)
      if (filterIndex != -1) {
        console.log("playerFilter")
        get().setToPlayerFilter(filters[filterIndex]);
      } else {
        set({ playerFilter: null });
      }
    }
  },
  setToCurrentFilter: (filter) => {
    if (filter) {
      if (filter.criteria) {
        let langFilters = {};
        let genreFilters = {};
        let decadeFilters = {};
        let items = filter.criteria.items;
        if (items) {
          items.forEach((arr) => {

            arr.forEach((criteria) => {

              switch (criteria.key) {
                case "language_id":
                  langFilters[criteria.value] = true;
                  break;
                case "genre_id":
                  genreFilters[criteria.value] = true;
                  break;
                case "decade":
                  decadeFilters[criteria.value] = true;
                  break;
              }
            });
          });
        }
        filter.filterLanguages = langFilters;
        filter.filterGenres = genreFilters;
        filter.filterDecades = decadeFilters;
        console.log("currentFilter e: " + JSON.stringify(filter));
        set({ currentFilter: filter });
      }
    }
  },
  getFilters: (sessionToken, isPlayerFilter = false, singer = null) => {
    set({ isWaiting: true });
    MuvikaService.getMusicFilters(sessionToken)
      .then(function (res) {
        console.log(res);
        if (res.data.error) {
          set({ filters: null, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ filters: res.data.data.items, totalCount: res.data.data.items_total, isWaiting: false });
          console.log("playerFilter", isPlayerFilter)
          if (isPlayerFilter) {
            let currentFilter = get().currentFilter;
            set({playerFilter: {...currentFilter}});
            let newSettings = { ...settingsStore.getState().settings };
            newSettings.music_style_id = currentFilter.id;
            settingsStore.getState().setSettings(sessionToken, newSettings, false);
            bgPerformanceStore.getState().filterOutPlayQueue(sessionToken, currentFilter, singer);
          }
        }
      })
      .catch(function () { });
  },
  setLocalCurrentFilter: (filter) => {
    get().setToCurrentFilter(filter);
  },
  setCurrentFilter: (filterId) => {
    let filters = get().filters;
    if (filters) {
      let filterIndex = filters.findIndex(x => x.id == filterId);
      if (filterIndex != -1) {
        get().setToCurrentFilter(filters[filterIndex]);
      }
    }
  },
  deleteFilter: (sessionToken, filterId) => {
    MuvikaService.deletePlayList(sessionToken, filterId)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let filters = get().filters;
          if (filters) {
            let filterIndex = filters.findIndex(x => x.id == filterId);
            if (filterIndex != -1) {
              filters.splice(filterIndex, 1);
              set({ currentFilter: null, filters: [...filters] });
              messageStore.getState().setMessage(sessionToken, TR.cm_deleted_big);
            }
          }
        }
      })
      .catch(function () { });
  },
  saveFilter: (sessionToken, filter, isPlayerFilter = false, singer = null) => {
    set({ isWaiting: true });
    let langFilters = filter.filterLanguages;
    let genreFilters = filter.filterGenres;
    let decadeFilters = filter.filterDecades;
    let items = MuvikaService.createMusicParameters(
      langFilters,
      genreFilters,
      decadeFilters
    );
    filter.criteria = {
      items: items
    };
    console.log(filter);
    MuvikaService.saveMusicFilter(sessionToken, filter)
      .then(function (res) {
        console.log(res);
        if (res.data.error) {
          set({ isWaiting: false });
          if (res.data.error.code == 7001) {
            let filters = get().filters;
            let filterIndex = filters.findIndex(x => x.name === filter.name);
            if (filterIndex !== -1) {
              messageStore.getState().setError(sessionToken, res.data.error.code, TR.cm_style_exists_already);
            }
          } else {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          }
        } else {
          let currentFilter = res.data.data;
          console.log(currentFilter);
          currentFilter.filterLanguages = langFilters;
          currentFilter.filterGenres = genreFilters;
          currentFilter.filterDecades = decadeFilters;
          console.log("currentFilter f: " + JSON.stringify(currentFilter));
          set({ isWaiting: false, currentFilter: { ...currentFilter } });
          get().getFilters(sessionToken, isPlayerFilter, singer);
        }
      })
      .catch(function () { });
  }
}));

export default bgFiltersStore;